import { createFileRoute, notFound } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import { EDITABLE_TITLE_RELOAD } from '@/lib/analytics/page-meta';
import { loadLearningTrackMeta } from '@/lib/queries/learning-tracks';
import { useMember, mayCreateResource } from '@/lib/use-session';
import {
  LearningTrackDetailSkeleton,
  LearningTrackDetailView,
} from '@/components/learning-tracks/LearningTrackDetailView';

export const Route = createFileRoute(
  '/_public/resources/learning-tracks/$trackId/',
)({
  beforeLoad: ({ params }) => {
    if (!isUuid(params.trackId)) throw notFound();
  },
  loader: {
    handler: ({ params, context: { queryClient } }) =>
      loadLearningTrackMeta(queryClient, params.trackId),
    staleReloadMode: EDITABLE_TITLE_RELOAD,
  },
  pendingComponent: LearningTrackDetailSkeleton,
  component: LearningTrackDetailPage,
});

function LearningTrackDetailPage() {
  const { trackId } = Route.useParams();
  const me = useMember();
  const canManage = me !== null && mayCreateResource(me.platformRole);
  return (
    <LearningTrackDetailView trackId={trackId} canManage={canManage} />
  );
}
